import { ReqParams } from "@/types";
import axiosInstance from "./axiosInstance";

export default class AdminService {

    static async getConnectedTenentWhatsappList(params: ReqParams = {}) {
        const response = await axiosInstance.get("/whatsapp/whatsAppAccount-config-list", { params });
        return response.data;
    }
    static async addWhatsAppSettingForTenent(data: any) {
        const response = await axiosInstance.post("/whatsapp/connect-tenant-whatsAppAccount", data);
        return response.data;
    }

    static async getConnectedTenentFacebookList(params: ReqParams = {}) {
        const response = await axiosInstance.get("/facebook-messenger/facebook-page-config-list", { params });
        return response.data;
    }
    static async addFacebookSettingForTenent(data: any) {
        const response = await axiosInstance.post("/facebook-messenger/connect-tenant-facebook-page", data);
        return response.data;
    }

    static async getFacebookPageDetails(id: string) {
        const response = await axiosInstance.get(`/facebook-messenger/facebook-page-config/${id}`);
        return response.data;
    }

    static async deleteFacebookPageConfig(id: string) {
        const response = await axiosInstance.delete(`/facebook-messenger/facebook-page-config/${id}`, { skipGlobalLoader: true });
        return response.data;
    }

    static async updateProfile(params: ReqParams = {}) {
        const response = await axiosInstance.patch("/admin/update-profile", params);
        return response.data;
    }

    static async updateFacebookSettingForTenent(id: string, data: any) {
        const response = await axiosInstance.put(`/facebook-messenger/facebook-page-config/${id}`, data);
        return response.data;
    }

    static async getTenentList() {
        const response = await axiosInstance.get("/whatsapp/whatsAppAccount-tenant-list");
        return response.data;
    }

    static async getTenentWhatsappDetails(id: string) {
        const response = await axiosInstance.get(`/whatsapp/whatsAppAccount-config/${id}`);
        return response.data;
    }

    // Retention Management — Super Admin sees the default retention policies
    // applied to all tenants unless a tenant overrides them.
    static async getRetentionDefaultPolicies(params: Record<string, unknown> = {}) {
        const response = await axiosInstance.get("/admin/retention/default-policies", { params });
        return response.data;
    }

    static async updateRetentionDefaultPolicy(dataClass: string, data: any) {
        const response = await axiosInstance.put(`/admin/retention/default-policies/${encodeURIComponent(dataClass)}`, data);
        return response.data;
    }
}
